/**
 * DocumentPreview.tsx
 * WYSIWYG HTML プレビュー iframe を表示するコンポーネント。
 * html-renderer が出力した HTML を srcDoc で受け取り、PDFと同一レンダラで描画する。
 */
import React from "react";

interface DocumentPreviewProps {
  htmlPreview: string;
  isDraft: boolean;
  editing: boolean;
}

export function DocumentPreview({ htmlPreview, isDraft, editing }: DocumentPreviewProps) {
  return (
    <div style={{ padding: "12px 20px 20px" }}>
      {isDraft && editing && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8, fontSize: 11, color: "#0f766e" }}>
          <span style={{ width: 7, height: 7, background: "#22c55e", borderRadius: "50%", display: "inline-block" }} />
          入力内容を変更するとプレビューが更新されます
        </div>
      )}
      <iframe
        srcDoc={htmlPreview}
        title="請求書プレビュー"
        style={{ width: "100%", height: 900, border: "1px solid #e2e8f0", borderRadius: 4, display: "block" }}
      />
    </div>
  );
}
